<template>
	<div class="diagnosis">
		<v-tabs
			vertical
			left
			color="primary"
			slider-color="primary"
			background-color="secondary"
			active-class="primary--text"
			style="border-radius: 4px"
		>
			<v-tab class="text-caption" v-translate v-if="$store.getters.hasAnyModule || biomedicalICD">Biomedical</v-tab>
			<v-tab class="text-caption" v-translate v-if="$store.getters.hasModule('mtc') || tcmICD">TCM</v-tab>
			<v-tab-item :transition="false" :reverse-transition="false">
				<v-container>
					<v-textarea
						filled
						class="text-body-2"
						:label="$gettext('Biomedical Diagnosis')"
						:placeholder="$gettext('Notes')"
						v-model="appointment.diagnosis_general"
						@blur="editAppointment"
						:disabled="cantEditBiomedical"
						auto-grow
						persistent-placeholder
					></v-textarea>
					<SearchICD
						:selectedICD="biomedicalICD"
						@add-icd="addICD"
						@remove-icd="removeICD"
						type="gen_diagnose"
						:disabled="cantEditBiomedical"
						:patient="appointment.patient"
					/>
				</v-container>
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false">
				<v-container>
					<v-textarea
						filled
						class="text-body-2"
						:label="$gettext('TCM Diagnosis')"
						:placeholder="$gettext('Notes')"
						v-model="appointment.diagnosis_mtc"
						@blur="editAppointment"
						:disabled="cantEditMTC"
						auto-grow
						persistent-placeholder
					></v-textarea>
					<SearchICD
						:selectedICD="tcmICD"
						@add-icd="addICD"
						@remove-icd="removeICD"
						type="mtc_diagnose"
						:disabled="cantEditMTC"
						:patient="appointment.patient"
					/>
				</v-container>
			</v-tab-item>
		</v-tabs>
	</div>
</template>

<script>
import SearchICD from "@/components/icd/SearchICD.vue";
import axios from "axios";

export default {
	name: "Diagnosis",
	props: ["appointment", "icds"],
	components: {
		SearchICD
	},
	data: () => ({}),
	computed: {
		biomedicalICD() {
			return this.icds.filter(s => s.type == "gen_diagnose");
		},
		tcmICD() {
			return this.icds.filter(s => s.type == "mtc_diagnose");
		},
		cantEditBiomedical() {
			return !this.$store.getters.hasAnyModule;
		},
		cantEditMTC() {
			return !this.$store.getters.hasModule('mtc');
		}
	},
	methods: {
		removeICD(icd) {
			if (icd) {
				this.icds.splice(this.icds.indexOf(icd), 1);
			}
		},
		addICD(icd) {
			if (icd) {
				this.icds.push(icd);
			}
		},
		editAppointment() {
			const patientId = this.$route.params.pid;
			const formData = new FormData();
			if(this.appointment.diagnosis_general) formData.append("diagnosis_general", this.appointment.diagnosis_general);
			if(this.appointment.diagnosis_mtc) formData.append("diagnosis_mtc", this.appointment.diagnosis_mtc);
			formData.append("diagnosis_submit", true);
			axios
				.post(
					"/patient/" + patientId + "/appointment/" + this.appointment.id,
					formData
				)
				.then(response => {
					console.log(response.data);
					if (response.status === 200) {
						if (response.data.result === "edited") {
							console.log("EDITED");
						}
					}
				})
				.catch(error => console.log(error));
		}
	}
};
</script>

<style scoped>
.v-tab {
	justify-content: left !important;
	min-width: 240px;
}
</style>